export default __webpack_public_path__ + "static/media/headshot.14a2db29.jpg";